// src/pages/DashboardPage.jsx
import MainLayout from "../layouts/MainLayout";
import StudentEntryForm from "./StudentEntryForm";
import { RegDataProvider } from '../context/RegDataContext';


const DashboardPage = () => {

  return (
    <MainLayout title="Student Entry Form">
      {/* Main Content */}
      <div style={{ flex: 1 }}>
        <RegDataProvider>
          <StudentEntryForm />
        </RegDataProvider>
      </div>
    </MainLayout>
  );
};

export default DashboardPage;
